import { asset1, asset2, asset3, asset4 } from './assets'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 'dieCast', position: 'Right' },
  // { src: asset2, x: 30.5847, y: 42.281, overlay: true },
  { src: asset3, x: 831.9325, y: -0.0002, itemId: 'dieCast', position: 'Left' },
  // { src: asset4, x: 863.7273, y: 42.2808, overlay: true },
]

const data = {
  assets: assets,
}

export default data
